import Vue from "vue";
import VueRouter from "vue-router";
import Nprogress from 'nprogress'
import { vuexOidcCreateRouterMiddleware } from 'vuex-oidc'
import store from '@/store'
import NotFoundView from "../views/404.vue";
// import login from "../views/Login.vue";
// import facility from "../component/master/Facility/FacilityLanding/FacilityLanding.vue"
// import facilityadd from "../component/master/Facility/FacilityAddUpdate/FacilityAddUpdate.vue"
// import rostering from "../views/Rostering/Rostering.vue";
// import selfRostering from '../views/SelfRostering/SelfRostering.vue';
// import tripManagement from '../views/TripManagement/TripManagement.vue'
// import EmployeeForm from "../component/master/employee/EmployeeForm.vue"
// import EmployeeList from "../component/master/employee/EmployeeList.vue";
import EmptyRouterView from '../components/EmptyRouterView/EmptyRouterView.vue';
// import EmployeeList from "../views/Employee/EmployeeList.vue"
// import EmployeeForm from "../views/Employee/EmployeeForm.vue"
// import facilityLanding from "../views/Facility/FacilityLanding.vue"
// import facilityadd from "../views/Facility/FacilityAddUpdate.vue"
// import vendor from '../views/Vendor/VendorLanding.vue'
// import vendoradd from '../views/Vendor/VendorAddUpdate.vue'
// import driver from '../views/Driver/DriverLanding.vue'
// import driveradd from '../views/Driver/DriverAddUpdate.vue'
// import Team from '../views/Team/Team.vue'
// import Shift from '../views/Shift/Shift.vue'
// import Process from '../views/Process/Process.vue'
// import Vehicle from '../views/Vehicle/Vehicle.vue'
// import VehicleForm from '../views/Vehicle/VehicleForm.vue'
// import VehicleCategoryList from '../views/VehicleCategory/VehicleCategoryList.vue'
// import VehicleCategoryForm from '../views/VehicleCategory/VehicleCategoryForm.vue'
// import LiveTrip from '../views/LiveTripMonitor/LiveTrip.vue'
// import settings from '../views/Settings/settings.vue'
// import dashboard from '../views/Dashboard/Dashboard.vue'
import icons from '../views/icons/icons.vue' /* To be removed */
import OidcCallback from '@/components/OidcCallback.vue';
import logoutSuccess from '@/components/LogoutSuccess.vue';
// import VendorBilling from '../views/Billing/vendor-billing.vue';
// import TripSetting from '../views/TripSetting/TripSetting.vue'
// import RaiseAdhocReqiconsuest from '../views/RaiseAdhocRequest/RaiseAdhocRequest.vue';
// import Usermanagement from '@/views/Users/Usermanagement.vue'
// import useradd from '../views/Users/UserAddUpdate.vue'
// import RaisedAdhocRequest from '../views/RaiseAdhocRequest/raisedRequests.vue'
// import VendorTripManualClose from '../views/VendorTripManualClose/Landing.vue'
// import NoShowApproval from '../views/NoShowApproval/NoShowApproval.vue'

Vue.use(VueRouter);
const routes = [
  // {
  //   path: '/user-management',
  //   beforeEnter: requireAuth,
  //   component: EmptyRouterView,
  //   meta: {
  //     title: 'User Management'
  //   },
  //   children: [
  //     {
  //       path: '',
  //       name: 'user-management',
  //       beforeEnter: requireAuth,
  //       // component: Usermanagement,
  //       component: () => import("../views/Users/Usermanagement"),
  //       meta: {
  //         title: 'User Management'
  //       }
  //     },
  //     {
  //       path: 'add',
  //       name: 'UserAddUpdate',
  //       beforeEnter: requireAuth,
  //       // component: useradd,
  //       component: () => import("../views/Users/UserAddUpdate.vue"),
  //       meta: {
  //         title: 'Add users'
  //       }
  //     }

  //   ]
  // },
  {
    path: "/",
    name: "Root",
    beforeEnter: requireRole,

  },
  // {
  //   path: "/dashboard",
  //   name: "dashboard",
  //   component: EmptyRouterView,
  //   meta: {
  //     title: 'Dashboard'
  //   },
  //   children: [
  //     {
  //       path: '',
  //       name: 'dashboard',
  //       component: () => import("../views/Dashboard/Dashboard-vts.vue"),
  //       meta: {
  //         title: 'dashboard'
  //       }
  //     }
  //   ]
  // },
  {
    path: "/reportsconfig",
    beforeEnter: requireAuth,
    component: EmptyRouterView,
    meta: {
      title: 'ReportConfig'
    },
    children: [
      {
        path: '',
        name: 'report',
        beforeEnter: requireAuth,
        // component: driver,
        component: () => import("../views/ReportConfig/ReportConfigList"),
        meta: {
          title: 'Report'
        }
      },
      {
        path: 'add',
        name: 'addReport',
        beforeEnter: requireAuth,
        // component: driveradd,
        component: () => import("../views/ReportConfig/AddReportConfig"),
        meta: {
          title: 'AddReportConfig '
        }
      }
    ]
  },
  {
    path:"/Device-Monitoring",
    beforeEnter:requireAuth,
    component:EmptyRouterView,
    meta:{
      title:'Device-Monitoring'
    },
    children:[
      {
        path:"",
        name:'Devicelanding',
        beforeEnter:requireAuth,
        component: () => import("../views/DeviceMonitoring/DeviceInfoTab"),
        meta: {
          title: 'Device-Monitoring'
        }
      }
    ],
  },
  {
    path: "/metadata",
    beforeEnter: requireAuth,
    component: EmptyRouterView,
    meta: {
      title: 'Metadata'
    },
    children: [
      {
        path: '',
        name: 'metadata',
        beforeEnter: requireAuth,
        // component: driver,
        component: () => import("../views/Metadata/MetadataList"),
        meta: {
          title: 'Metadata'
        }
      },
      {
        path: 'add',
        name: 'addMetadata',
        beforeEnter: requireAuth,
        // component: driveradd,
        component: () => import("../views/Metadata/AddMetadata"),
        meta: {
          title: 'AddMetadata'
        }
      }
    ]
  },

  {
    path: "/iot-exposer",
    beforeEnter: requireAuth,
    component: EmptyRouterView,
    meta: {
      title: 'IOTExposer'
    },
    children: [
      {
        path: '',
        name: 'iotLanding',
        beforeEnter: requireAuth,
        // component: deviceadd,
        component: () => import("../views/IOTExposer/IOTLanding"),
        meta: {
          title: 'IOTExposer'
        }        
      },
      {
        path: 'IOTadd',
        name: 'iotAddUpdate',
        beforeEnter: requireAuth,
        // component: deviceadd,
        component: () => import("../views/IOTExposer/IOTAddUpdate"),
        meta: {
          title: 'IOTExposer'
        }        
      },
    ]
  },

  {
    path: "/device",
    beforeEnter: requireAuth,
    component: EmptyRouterView,
    meta: {
      title: 'Device'
    },
    children: [
      {
        path: '',
        name: 'deviceLanding',
        beforeEnter: requireAuth,
        // component: device,
        component: () => import("../views/Device/DeviceLanding"),
        meta: {
          title: 'Device'
        }
      },
      {
        path: 'add',
        name: 'deviceAddUpdate',
        beforeEnter: requireAuth,
        // component: deviceadd,
        component: () => import("../views/Device/DeviceAddUpdate"),
        meta: {
          title: 'Device'
        }
      },
      // {
      //   path: 'IOT',
      //   name: 'iotLanding',
      //   beforeEnter: requireAuth,
      //   // component: deviceadd,
      //   component: () => import("../views/IOTExposer/IOTLanding"),
      //   meta: {
      //     title: 'Device'
      //   }        
      // },
      // {
      //   path: 'IOTadd',
      //   name: 'iotAddUpdate',
      //   beforeEnter: requireAuth,
      //   // component: deviceadd,
      //   component: () => import("../views/IOTExposer/IOTAddUpdate"),
      //   meta: {
      //     title: 'Device'
      //   }        
      // },
    ]
  },


  
  {
    path: "/report-master",
    beforeEnter: requireAuth,
    component: EmptyRouterView,
    meta: {
      title: 'ReportMaster'
    },
    children: [
      {
        path: '',
        name: 'reportMaster',
        beforeEnter: requireAuth,
        component: () => import("../views/ReportMaster/ReportMaster"),
        meta: {
          title: 'ReportMaster'
        }
      },
      {
        path: 'add',
        name: 'reportMasterAdd',
        beforeEnter: requireAuth,
        component: () => import("../views/ReportMaster/AddReportMaster.vue"),
        meta: {
          title: 'ReportMaster'
        }
      },
      
    ]
  },

  {
    path: "/configsettings",
    beforeEnter: requireAuth,
    component: EmptyRouterView,
    meta: {
      title: 'Configuration'
    },
    children: [
      {
        path: '',
        name: 'configuration',
        beforeEnter: requireAuth,
        // component: device,
        component: () => import("../views/Configuration/ConfigurationList"),
        meta: {
          title: 'Configuration'
        }
      },
      {
        path: 'add',
        name: 'configurationAddUpdate',
        beforeEnter: requireAuth,
        // component: deviceadd,
        component: () => import("../views/Configuration/AddConfiguration"),
        meta: {
          title: 'Configuration'
        }
      },
      {
        path: 'addDB',
        name: 'DBAddUpdate',
        beforeEnter: requireAuth,
        // component: deviceadd,
        component: () => import("../views/Configuration/DBAddUpdate"),
        meta: {
          title: 'Configuration'
        }
      }
    ]
  },
  {
    path: "/sensor-management",
    beforeEnter: requireAuth,
    component: EmptyRouterView,
    meta: {
      title: 'Sensor'
    },
    children: [
      {
        path: '',
        name: 'sensorLanding',
        beforeEnter: requireAuth,
        // component: Sensor,
        component: () => import("../views/Sensor/SensorLanding"),
        meta: {
          title: 'Sensor'
        }
      },
      {
        path: 'add',
        name: 'sensorAddUpdate',
        beforeEnter: requireAuth,
        // component: Sensoradd,
        component: () => import("../views/Sensor/SensorAddUpdate"),
        meta: {
          title: 'Sensor'
        }
      }
    ]
  },
  {
    path: "/vehicle-management",
    beforeEnter: requireAuth,
    component: EmptyRouterView,
    meta: {
      title: 'vehicle'
    },
    children: [
      {
        path: '',
        name: 'vehicle-management',
        beforeEnter: requireAuth,
        component: () => import("../views/VehicleType/VehicleInfoTab.vue"),
        meta: {
          title: 'vehicle'
        }
      },
      {
        path: 'add',
        name: 'VehicleForm',
        beforeEnter: requireAuth,
        component: () => import("../views/Vehicle/VehicleForm"),
        meta: {
          title: 'Vehicle'
        }
      }
    ]
  },
  {
    path: "/vehicle-category",
    beforeEnter: requireAuth,
    component: EmptyRouterView,
    meta: {
      title: 'vehicle-category'
    },
    children: [
      {
        path: '',
        name: 'vehicle-category',
        beforeEnter: requireAuth,
        component: () => import("../views/VehicleCategory/VehicleCategoryList"),
        meta: {
          title: 'catevehicle-categorygory'
        }
      },
      {
        path: 'add',
        name: 'VehicleCategoryForm',
        beforeEnter: requireAuth,
        component: () => import("../views/VehicleCategory/VehicleCategoryForm"),
        meta: {
          title: 'catevehicle-categorygory'
        }
      }
    ]
  },
  {
    path: "/vehicle-type",
    beforeEnter: requireAuth,
    component: EmptyRouterView,
    meta: {
      title: 'vehicle-type'
    },
    children: [
      {
        path: '',
        name: 'VehicleType',
        beforeEnter: requireAuth,
        component: () => import("../views/VehicleType/VehicleType"),
        meta: {
          title: 'Vehicle Type'
        }
      },
      {
        path: 'add',
        name: 'VehicleTypeAdd',
        beforeEnter: requireAuth,
        component: () => import("../views/VehicleType/VehicleTypeAdd"),
        meta: {
          title: 'Vehicle Type'
        }
      }
    ]
  },
  // {
  //   path: '/process-management',
  //   beforeEnter: requireAuth,
  //   component: () => import("../views/Process/Process"),
  //   meta: {
  //     title: 'Master Routing'
  //   }
  // },
  {
    path: '/sos-list',
    name: 'sos',
    beforeEnter: requireAuth,
    component: () => import("../views/ListSos/List.vue"),
    meta: {
      title: 'sos'
    }
  },
  // {
  //   path: '/shift',
  //   beforeEnter: requireAuth,
  //   component: () => import("../views/Shift/Shift.vue"),
  //   meta: {
  //     title: 'Setting menu'
  //   }
  // },
  // {
  //   path: '/facility',
  //   beforeEnter: requireAuth,
  //   component: () => import("../views/Facility/Facility.vue"),
  //   meta: {
  //     title: 'Setting menu'
  //   }
  // },
  // {
  //   path: '/rosteringsetting',
  //   beforeEnter: requireAuth,
  //   component: () => import("../views/RosterSettings/RosterSettings.vue"),
  //   meta: {
  //     title: 'Setting menu'
  //   }
  // },
  // {
  //   path: "/Team",
  //   beforeEnter: requireAuth,
  //   component: Team,
  //   meta: {
  //     title: 'Team'
  //   }
  // },
  // {
  //   path: '/orgsetting',
  //   beforeEnter: requireAuth,
  //   name: 'orgsetting',
  //   component: () => import("../views/Org/Org"),
  //   meta: {
  //     title: 'Org'
  //   }
  // },
  // {
  //   path: '/profile',
  //   beforeEnter: requireAuth,
  //   component: () => import("../views/Profile/Profile.vue"),
  //   meta: {
  //     title: 'Profile'
  //   }
  // },
  // {
  //   path: '/userandrolessetting',
  //   beforeEnter: requireAuth,
  //   name: 'user-role',
  //   component: () => import("../views/UserRole/UserRole.vue"),
  //   meta: {
  //     title: 'setting menu'
  //   }
  // },
  // {
  //   path: '/activate-deactivate',
  //   beforeEnter: requireAuth,
  //   component: () => import("../views/AcivateDeactivate/ActivateEmp.vue"),
  //   meta: {
  //     title: 'Master Routing'
  //   }
  // },
  // {
  //   path: "/employee-shift-adjustment",
  //   beforeEnter: requireAuth,
  //   component: Shift,
  //   meta: {
  //     title: 'Shift'
  //   }
  // },
  {
    path: "/settings",
    beforeEnter: requireAuth,
    name: 'settings',
    // component: settings,
    component: () => import("../views/Settings/settings"),
    meta: {
      title: 'Settings'
    },
  },
  {
    path: "/vehicle-speed-limit",
    beforeEnter: requireAuth,
    component: EmptyRouterView,
    meta: {
      title: 'vehicle'
    },
    children: [
      {
        path: '',
        name: 'vehicle-speed-limit',
        beforeEnter: requireAuth,
        component: () => import("../views/VehicleSpeedLimit/VehicleSpeedLimit"),
        meta: {
          title: 'Vehicle Speed Limit'
        }
      },
      {
        path: '/vehicle-speed-limit/add',
        name: 'vehicle-speed-limit-add',
        beforeEnter: requireAuth,
        component: () => import("../views/VehicleSpeedLimit/AddUpdateSpeedLimit"),
        meta: {
          title: 'Vehicle Speed Limit'
        }
      }
    ]
  },
  {
    path: "/user-management",
    beforeEnter: requireAuth,
    component: EmptyRouterView,
    meta: {
      title: 'User Management'
    },
    children: [
      {
        path: '',
        name: 'user-management',
        beforeEnter: requireAuth,
        component: () => import("../views/UserManagement/UserManagement"),
        meta: {
          title: 'User Management'
        }
      },
      {
        path: '/user-management/add',
        name: 'user-management-add',
        beforeEnter: requireAuth,
        component: () => import("../views/UserManagement/AddUpdateUser"),
        meta: {
          title: 'User Management'
        }
      }
    ]
  },
  {
    path: "/vehicle-user-map",
    beforeEnter: requireAuth,
    component: EmptyRouterView,
    meta: {
      title: 'Vehicle User Map'
    },
    children: [
      {
        path: '',
        name: 'vehicle-user-map',
        beforeEnter: requireAuth,
        component: () => import("../views/VehicleUserMap/VehicleUserMap"),
        meta: {
          title: 'Vehicle User Map'
        }
      },
    ]
  },
  {
    path: "/distance-travel-report",
    beforeEnter: requireAuth,
    component: EmptyRouterView,
    meta: {
      title: 'Distance Travel Report'
    },
    children: [
      {
        path: '',
        name: 'distance-travel-report',
        beforeEnter: requireAuth,
        component: () => import("../views/Reports/DistanceTravelReport/DistanceTravelReport"),
        meta: {
          title: 'Distance Travel Report'
        }
      },
    ]
  },
  {
    path: "/ignition-onoff-report",
    beforeEnter: requireAuth,
    component: EmptyRouterView,
    meta: {
      title: 'Ignition On Off Report'
    },
    children: [
      {
        path: '',
        name: 'ignition-onoff-report',
        beforeEnter: requireAuth,
        component: () => import("../views/Reports/IgnitionOnOffReport/IgnitionOnOffReport"),
        meta: {
          title: 'Ignition On Off Report'
        }
      },
    ]
  },
  {
    path: "/travel-path-report",
    beforeEnter: requireAuth,
    component: EmptyRouterView,
    meta: {
      title: 'Travel Path Report'
    },
    children: [
      {
        path: '',
        name: 'travel-path-report',
        beforeEnter: requireAuth,
        component: () => import("../views/Reports/TravelPathReport/TravelPathReport"),
        meta: {
          title: 'Travel Path Report'
        }
      },
    ]
  },
  {
    path: "/change-password",
    name: "change-password",
    beforeEnter: requireAuth,
    component: EmptyRouterView,
    meta: {
      title: 'Change Password'
    },
    children: [
      {
        path: '',
        name: 'change-password',
        beforeEnter: requireAuth,
        component:  () => import("../views/ChangePassword/ChangePassword"),
        meta: {
          title: 'Change Password'
        }
      }
    ]
  },
  {
    path: "/reports",
    beforeEnter: requireAuth,
    component: EmptyRouterView,
    meta: {
      title: 'Reports'
    },
    children: [
      {
        path: '',
        beforeEnter: requireAuth,
        name: 'Reports',
        component: () => import("../views/Report/Report.vue"),
        meta: {
          title: 'Reports'
        }
      },
      {
        path: 'report-details',
        name: 'report-details',
        beforeEnter: requireAuth,
        component: () => import("../views/Report/CustomReport.vue"),
        meta: {
          title: 'Report Details'
        },
        props: true
      }
    ]
  },
  {
    path: '/tenantsettings',
    beforeEnter: requireAuth,
    name: 'tenantsettings',
    component: () => import("../views/TenantSettings/TenantSettings.vue"),
    meta: {
      title: 'tenantsettings'
    }
  },
  // {
  //   path: "/raise-adhoc-request",
  //   beforeEnter: requireAuth,
  //   name: 'RaiseAdhocRequest',
  //   // component: RaiseAdhocRequest,
  //   component: () => import("../views/RaiseAdhocRequest/RaiseAdhocRequest"),
  //   meta: {
  //     title: 'Raise Adhoc Request'
  //   },
  // },
  // {
  //   path: "/raised-adhoc-requests",
  //   beforeEnter: requireAuth,
  //   name: 'RaisedAdhocRequest',
  //   // component: RaisedAdhocRequest,
  //   component: () => import("../views/RaiseAdhocRequest/raisedRequests"),
  //   meta: {
  //     title: 'Raised Adhoc Request'
  //   },
  // },
  // {
  //   path: "/vendor-trip-sheet",
  //   beforeEnter: requireAuth,
  //   name: 'VendorTripSheet',
  //   component: () => import("../views/VendorTripSheet/VendorTripSheet"),
  //   meta: {
  //     title: 'Vendor Trip Sheet'
  //   },
  // },

  // {
  //   path: "/metadatasetting",
  //   beforeEnter: requireAuth,
  //   name: 'Meta Data',
  //   component: () => import("../views/MetaData/MetaData.vue"),
  //   meta: {
  //     title: 'Meta Data'
  //   },
  // },

  {
    path: "/icons",
    name: "icons",
    beforeEnter: requireAuth,
    component: EmptyRouterView,
    meta: {
      title: 'icons'
    },
    children: [
      {
        path: '',
        name: 'icons',
        beforeEnter: requireAuth,
        component: icons,
        meta: {
          title: 'icons'
        }
      }
    ]
  },
  // {
  //   path: "/tenantcostcomponent",
  //   beforeEnter: requireAuth,
  //   component: EmptyRouterView,
  //   meta: {
  //     title: 'Cost Component'
  //   },
  //   children: [
  //     {
  //       path: '',
  //       name: 'cost-component',
  //       beforeEnter: requireAuth,
  //       component: () => import("../views/CostComponent/CostComponentList"),
  //       meta: {
  //         title: 'Cost Component'
  //       }
  //     },
  //     {
  //       path: 'add',
  //       name: 'add-cost-component',
  //       beforeEnter: requireAuth,
  //       component: () => import("../views/CostComponent/AddCostComponent"),
  //       meta: {
  //         title: 'Add Cost Component'
  //       },
  //       props: true
  //     }
  //   ]
  // },
  // {
  //   path: "/billcategory",
  //   beforeEnter: requireAuth,
  //   component: EmptyRouterView,
  //   meta: {
  //     title: 'Billing Component'
  //   },
  //   children: [
  //     {
  //       path: '',
  //       name: 'billing-list',
  //       beforeEnter: requireAuth,
  //       component: () => import("../views/Billing/BillingCategoryList"),
  //       meta: {
  //         title: 'Billing'
  //       }
  //     },
  //     {
  //       path: 'add',
  //       name: 'add-billing-category',
  //       beforeEnter: requireAuth,
  //       component: () => import("../views/Billing/AddBillingCategory"),
  //       meta: {
  //         title: 'Add Billing Category'
  //       },
  //       props: true
  //     }
  //   ]
  // },
  // {
  //   path: "/icons",
  //   name: "icons",
  //   beforeEnter: requireAuth,
  //   component: EmptyRouterView,
  //   meta: {
  //     title: 'icons'
  //   },
  //   children: [
  //     {
  //       path: '',
  //       name: 'icons',
  //       beforeEnter: requireAuth,
  //       component: icons,
  //       meta: {
  //         title: 'icons'
  //       }
  //     }
  //   ]
  // },
  // {
  //   path: "/vendor-billing",
  //   name: "venorBilling",
  //   beforeEnter: requireAuth,
  //   component: EmptyRouterView,
  //   meta: {
  //     title: 'venorBilling'
  //   },
  //   children: [
  //     {
  //       path: '',
  //       name: 'venorBilling',
  //       beforeEnter: requireAuth,
  //       component: VendorBilling,
  //       meta: {
  //         title: 'Vendor Billing'
  //       }
  //     }
  //   ]
  // },
  // {
  //   path: "/routingsetting",
  //   beforeEnter: requireAuth,
  //   name: 'Route Setting',
  //   // component: NoShowApproval,
  //   component: () => import("../views/RouteSetting/RouteSetting.vue"),
  //   meta: {
  //     title: 'Route Setting'
  //   },
  // },
  // {
  //   path: "/tripsetting",
  //   beforeEnter: requireAuth,
  //   name: 'Trip Setting',
  //   // component: NoShowApproval,
  //   component: () => import("../views/TripSetting/TripSetting.vue"),
  //   meta: {
  //     title: 'Trip Setting'
  //   },
  // },
  // {
  //   path: "/facility-seat-booking",
  //   beforeEnter: requireAuth,
  //   name: 'Facility Seat Booking',
  //   // component: NoShowApproval,
  //   component: () => import("../views/SeatBooking/FacilitySeatBooking.vue"),
  //   meta: {
  //     title: 'Facility Seat Booking'
  //   },
  // },

  // {
  //   path: "/workspace_booking",
  //   beforeEnter: requireAuth,
  //   component: EmptyRouterView,
  //   name: 'FacilitySeatBooking',
  //   meta: {
  //     title: 'Facility Seat Booking',
  //   },
  //   children: [
  //     {
  //       path: '',
  //       name: 'FacilitySeatBooking',
  //       beforeEnter: requireAuth,
  //       component: () => import("../views/SeatBooking/FacilitySeatBooking.vue"),
  //       meta: {
  //         title: 'Seat Booking'
  //       }
  //     },
  //     {
  //       path: 'booked-seat',
  //       name: 'BookedSeat',
  //       beforeEnter: requireAuth,
  //       component: () => import("../views/SeatBooking/BookedSeat.vue"),
  //       meta: {
  //         title: 'Booked Seat'
  //       }
  //     },
  //     {
  //       path: 'awaiting-aaproval',
  //       name: 'awaitingApproval',
  //       beforeEnter: requireAuth,
  //       component: () => import("../views/SeatBooking/AwaitingApproval.vue"),
  //       meta: {
  //         title: 'Awaiting Approval'
  //       }
  //     },

  //   ]
  // },

  {
    path: '/callback', // Needs to match redirectUri (redirect_uri if you use snake case) in you oidcSettings
    name: 'oidcCallback',
    component: OidcCallback,
    meta: { layout: "loginlayout", title: 'Login', isPublic: true }
  },
  {
    path: '/logoutSuccess',
    name: 'Logout',
    component: logoutSuccess,
    meta: { layout: "loginlayout", title: 'Logout', isPublic: true }
  },
  // {
  //   path: '/osm',
  //   name: 'open-street-map',
  //   // beforeEnter: requireAuth,
  //   // component: Usermanagement,
  //   component: () => import("../components/OpenStreetMap/OpenStreetMap.vue"),
  //   meta: {
  //     title: 'User Management'
  //   }
  // },
  // {
  //   path: '/reports',
  //   beforeEnter: requireAuth,
  //   name: 'Reports',
  //   component: () => import("../views/Report/Report.vue"),
  //   meta: {
  //     title: 'Reports'
  //   }
  // },
  {
    path: "*",
    component: NotFoundView,
    meta: { title: 'under construction' }
  }
];

export function requireAuth(to, from, next) {
  // let menuUrl = store.state
  // console.log("menuUrl", menuUrl)
  next()
  // }
  // if (localStorage.getItem('access_token') == null) {
  //   next("/login");
  // } else {

  // }

}

export function requireRole(to, from, next) {
  let menuUrl = store.state
  console.log('menuUrl.oidcStore.user.role', menuUrl.oidcStore.user.role)
  // if (menuUrl.oidcStore.user.role != 'SuperAdmin' && menuUrl.oidcStore.user.role != 'Vendor') {

  //   return next({ path: '/profile' });
  // }
  // else if (menuUrl.oidcStore.user.role == 'Vendor') {
  //   return next({ path: '/vendor-trip-sheet' });
  // }
  // else {
  //   return next({ path: '/dashboard' });
  // }
  next({ path: '/device' })
}

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  linkActiveClass: "active"
});

export default router;
router.beforeEach(vuexOidcCreateRouterMiddleware(store, 'oidcStore'))

router.beforeResolve((to, from, next) => {
  if (to.name) {
    Nprogress.start()
  }
  next()
});

router.afterEach(() => {
  Nprogress.done()
});
